module.exports = __webpack_public_path__ + "img/pr-14.a2b21ff5.png";